module.exports = __webpack_public_path__ + "img/sass.4bead3dd.png";